import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { DocumentManagementRoutingModule } from './document-management-routing.module';
import { ComponentsModule } from '@app/components/components.module';
import { DocumentListComponent } from './containers/document-list/document-list.component';
import { DocumentDetailComponent } from './containers/document-detail/document-detail.component';

import { SafePipe } from '@app/commons/pipes/safe.pipe';
import { SharedModule } from '@app/commons/sharad.module';
import { DocumentFilterModalComponent } from './document-filter-modal/document-filter-modal.component';
import { containers } from './containers';


@NgModule({
  declarations: [
    ...containers,
    SafePipe,
    DocumentFilterModalComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    ComponentsModule,
    DocumentManagementRoutingModule,
  ]
})
export class DocumentManagementModule { }
